import n from "./design-system.es38.js";
import { resolveComponent as r, openBlock as s, createBlock as a, mergeProps as i, createSlots as p, renderList as c, withCtx as m, renderSlot as u } from "vue";
import f from "./design-system.es128.js";
const l = {
  name: "DsOutlineButton",
  compatConfig: { MODE: 3 },
  components: { DsButton: n },
  inheritAttrs: !1
};
function _(t, B, $, d, D, h) {
  const e = r("DsButton");
  return s(), a(e, i(t.$attrs, { variant: "outline" }), p({ _: 2 }, [
    c(t.$slots, (C, o) => ({
      name: o,
      fn: m(() => [
        u(t.$slots, o)
      ])
    }))
  ]), 1040);
}
const v = /* @__PURE__ */ f(l, [["render", _]]);
export {
  v as default
};
//# sourceMappingURL=design-system.es82.js.map
